export { default } from './TotalAmount'
